"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_VIDEO_CARD_QUERY = void 0;
var helpers_1 = require("../../client/helpers");
var fragments_1 = require("./fragments");
exports.GET_VIDEO_CARD_QUERY = "\n  query GetVideoCards($videoId: ID!) {\n    video(filter: { id: $videoId }) {\n      cards(limit: 100) {\n        entities {\n          ...VideoCardFragment\n        }\n      }\n    }\n  }\n  " + fragments_1.VIDEO_CARD_FRAGMENT + "\n";
//# sourceMappingURL=queries.js.map